<template>
  <div class="page--crud_view">
    <div class="inner-wrap">
      <div class="content" v-if="Object.keys(data).length>0">
        <div class="row" v-for="(row,index) in currentSetting.view" :key="index">
          <div class="item" v-for="(item,j) in row" :key="j">
            <Component :is="item.component" v-if="item.type == 'component' && !load" :data="data" :action="'View'" :k="key" :field="item"/>
            <div class="data" v-else-if="item.type == 'componentColumn'">
              <div class="label">{{ tran(key, `${typeof item == "object" ? item.key : item}`) }}</div>
              <div class="value" :class="item.type ? item.type : 'text'">
                <Component :is="item.component" :options="options" :action="'View'" :k="key" :field="item" :data="data" :ref="`componentColumn-${item.key}`"/>
              </div>
            </div>
            <div v-else-if="typeof item == 'object' && item.type == 'tabs' && !load" class="item__type--tab">
              <el-tabs type="border-card">
                <el-tab-pane :label="$t(`menu.item.${tab.name}`)" v-for="tab in item.items" :key="tab.key" :lazy="true">
                  <RelatedInfoDataTable :option="tab" :params="params[tab.key]"/>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="data" v-else>
              <div class="label">{{ tran(key, `${typeof item == "object" ? item.key : item}`) }}</div>
              <div class="value" :class="item.type ? item.type : 'text'">
                <div v-if="item.type == 'boolean'">
                  <input type="checkbox" :checked="getValue(item) == 1"/>
                  <div class="block-layer"></div>
                </div>
                <div v-else-if="item.type == 'datetime'">
                  {{ getValue(item) ? $moment(getValue(item)).format("YYYY-MM-DD HH:mm:ss") : "" }}
                </div>
                <div v-else-if="item.type == 'array'">
                  {{ getArrayValue(item) }}
                </div>
                <div v-else-if="item.type == 'select' && item.options">
                  {{selectOptions(item)}}
                </div>
                <div class="json" v-else-if="isJson(getValue(item))">
                  <vue-json-pretty
                    :data="JSON.parse(getValue(item))"
                  >
                  </vue-json-pretty>
                </div>
                <div class="text" v-else>{{ getValue(item) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="extra-component" v-if="currentSetting.extra_components && currentSetting.extra_components.view">
          <component class="component" v-for="(component,index) in currentSetting.extra_components.view" :key="index" :is="component" :action="'View'" :data="data"></component>
        </div>
          <div class="extra-component" v-if="currentSetting.extra_privillege_components && currentSetting.extra_privillege_components.view">
              <component class="component" v-for="(row,index) in currentSetting.extra_privillege_components.view"  v-if="check_prvillege(row)" :action="'View'" :key="index" :is="row.component" :data="data" :setup="row"></component>
          </div>
      </div>
      <div class="action">
        <!-- <router-link :to="{ name: 'List', params: { key } }">{{ $t("button.back") }}</router-link> -->
        <el-button type="info" @click="$router.push({ name: 'List', params: { key } })">{{ $t("button.back") }}</el-button>
        <el-button type="primary" @click="$router.push({ name: 'Edit', params: { key } })" v-if="hasRightToEdit">{{ $t("button.edit") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css';
import RelatedInfoDataTable from "@/views/crud/modules/RelatedInfoDataTable";
import { mapState } from 'vuex';

export default {
  components: {
    VueJsonPretty,
    RelatedInfoDataTable
  },
  props: {
    // namespace: String,
    // setting: {
    //   type: Array,
    //   default() {
    //     return [];
    //   }
    // },
    // data: {
    //   type: Object,
    //   default() {
    //     return {};
    //   }
    // }
  },
  async beforeMount() {
    this.key = this.$route.params.key;
    Object.assign(this.currentSetting, this.$setting.crud[this.key]);
    this.currentSetting.fields = [...this.currentSetting.fields.filter(f=>f.type!="action-btn")];
    this.$store.commit("control/setLoad", true);
    if(this.currentSetting.options) {
        await this.$axios.get(`options?opts=${Object.keys(this.currentSetting.options).map(key=>this.currentSetting.options[key].key).join("&opts=")}`, {
          params: {
            // opts: 
          }
        }).then(res=>{
          let options = res.data.response.options;
  
          Object.keys(this.currentSetting.options).filter(opt=>options.hasOwnProperty(this.currentSetting.options[opt].key)).map(opt=>{
            console.log(opt);
            let key = this.currentSetting.options[opt].key;
            this.options[key] = options[key].map(value=>{
              return {
                label: typeof value == "object" ? value[this.currentSetting.options[opt].label] : value,
                value: typeof value == "object" ? value[this.currentSetting.options[opt].value] : value,
              }
            });
          });
          return true;
        }).catch(err=>{ return false; });
      }
    this.data = (await this.$axios.get(`/${this.currentSetting?.api?.view ? this.currentSetting?.api?.view : this.key}/${this.$route.params.id}`)).data;
    this.currentSetting.view = [...this.currentSetting.view.filter(f => {
        if (f?.type == "action-btn") return false;
        if (f?.hidden?.includes("write")) return false;

        // privilege check
        if (f[0]?.privilege) {
            console.log("privilege", f.privilege);
            let auth = true;
            f[0].privilege.map(p => {
                if (!this.permissions.includes(p)) {
                    console.log("p: ", p);
                    auth = false;
                }
            });
            console.log("auth: ", auth);
            return auth;
        }
        //
        if (typeof f.hidden == "undefined") return true;
        return true;
    })];
    this.currentSetting.view.map(v=>{
      v.map(item=>{
        if(typeof item == 'object' && item.type == 'tabs') {
          for(let i=0; i<item.items.length; i++) {
            this.params[item.items[i].key] = this.getParams(item.items[i].params, this.data);
          }
          // item.items.map((index, tab)=>{
          //   console.log("params: ",index);
          //   this.params[index] = this.getParams(tab.params, this.data);
          // });
        }
      });
    });
    this.$store.commit("control/setLoad", false);
    // this.currentSetting.fields.map(field=>{
    //   console.log(typeof field.protected);
    //   if(!(typeof field.protected == "boolean" && field.protected)) {
    //     if(data[field.key] != null && typeof data[field.key] == "object") {
    //       if(field.value) {
    //         console.log("field.value: ",field.value);
    //         this.data[field.key] = this.getValueByField(data, field.value);
    //       }else {
    //         this.data[field.key] = data[this.currentSetting.id];
    //       }
    //     }else {
    //       this.data[field.key] = data.hasOwnProperty(field.key) && data[field.key] !== null ? `${data[field.key]}` : "";
    //     }
    //   }
    // });
    // this.data[this.currentSetting.id] = data[this.currentSetting.id];
    this.$forceUpdate();
  },
  methods: {
    selectOptions(item){
      var str = "";
      if(this.options[item.options.key] != undefined){
        str = this.options[item.options.key].filter(
          option => {
              if (option.value == data[item.key]){
                return true;
              }
            return false;
          }
        )[0]?.label;
      }
      return str;
    },
    getValue(field) {
      let split = [];
      if(field.value) {
        split = field.value.split(".");
      }else if(field.key) {
        split = field.key.split(".");
      }else if(typeof field == "string") {
        split = field.split(".");
      }
      if(split.length == 1) return field.key ? this.data[field.key] : this.data[field];
      let value = this.data;
      window.data = this.data;
      // if(split.length > 0) split.unshift(field.key);
      split.map(f=>{
        if(value[f] != null) {
          value = value[f];
        }else {
          value = "";
        }
        // console.log(value);
      });
      return value;
    },
    getValueByField(row, field) {
      // if(Array.isArray())
      // console.log(field);
      let split = field.split(".");
      let value = row;
      // if(split.length > 0) split.unshift(field.key);
      split.map(f=>{
        if(typeof value != "object") return;
        if(Array.isArray(value[f]) && split.length >= 2) {
          let list = value[f];
          value = list.map(arr=>arr[split[1]]).join(", ");
        }else {
          value = value.hasOwnProperty(f) ? value[f] : "";
        }
      });
      return value;
    },
    isJson(value) {
      if(value === null) return false;
      if(!isNaN(parseInt(value))) return false;
      try{
        JSON.parse(value);
        return true;
      }catch(err) {
        return false;
      }
    },
    getParams(params, data) {
      let obj = {};
      params = params ? params : [];
      params.map(p=>{
        let field = this.currentSetting.fields.find(f=>f.key==p);
        if(field == null) return;
        if(data.hasOwnProperty(p)) {
          // if(field.type = "multiselect") {
          //   obj[p] = [data[p]]
          // }else {
          //   obj[p] = data[p];
          // }
          obj[p] = data[p];
        }
      });
      return obj;
    },
    getArrayValue(item) {
      let values = this.getValue(item.field);
      if(typeof values == "undefined") return;
      return values.map(v=>v[item.value]).join(", ");
    },
    check_prvillege(f){
      console.log(f)
      let auth = true;
      if(f?.privilege) {
        console.log("privilege", f.privilege);
        f.privilege.map(p=>{
          if(!this.permissions.includes(p)) {
            console.log("p: ", p);
            auth = false;
          }
        });
        console.log("auth: ",auth);
      }
      return auth;
    }
  },
  computed: {
    ...mapState({
      load: state => state.control.load,
      permissions: state => state.user.user_info.permissions
    }),
    hasRightToEdit() {
      return this.currentSetting.action && this.currentSetting.action.includes('edit') && this.permissions.includes(`EDIT_${this.currentSetting.key}`.toUpperCase());
    },
  },
  data() {
    return {
      key: "",
      currentSetting: {},
      data: {},
      params: {},
      options: {}
    }
  }
}
</script>

<style lang="scss">
.page--crud_view{
  // height: 90vh;
  background: white;
  border-radius: 3px;
  overflow: auto;
  & > .inner-wrap{
    padding: 10px;
    .content{
      .row{
        display: flex;
        margin-bottom: 20px;
        width: 100%;
        max-width: 100%;
        .item{
          flex-grow: 1;
          display: flex;
          width: 100%;
          font-size: x-small;
          // margin-right: 20px;
          .item__type--tab{
            flex-grow: 1;
            overflow-x: auto;
          }
          .data{
            width: 100%;
            display: flex;
          }
          .label{
            width: 130px;
            min-width: 130px;
            display: flex;
            // align-items: center;
          }
          .value{
            min-width: 200px;
            width: 100%;
            border: 1px solid gray;
            background-color: #E6E6E6 !important;
            padding: 3px 5px;
            min-height: 18px;
            height: 100%;
            display: flex;
            align-items: center;
            &.boolean{
              background-color: white!important;
              border-color: white;
              position: relative;
              & > *{
                // display: flex;
                // justify-content: flex-end;
              }
            }
            .block-layer{
              position: absolute;
              height: 100%;
              width: 100%;
              top: 0;
              left: 0;
              z-index: 1;
            }
            .json{
              .vjs-tree.is-root{
                &,.vjs-key,.vjs-value{
                  font-size: xx-small;
                }
              }
            }
          }
          &:not(:first-child) {
            margin-left: 10px;
          }
        }
      }
      .extra-component{
        margin-bottom: 20px;
      }
    }
  }
  .action{
    display: flex;
    justify-content: space-between;
  }
}
</style>